import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';
import { validaInterno, validaEsterno } from '../../config/validators';
import { defineMessages, useIntl } from 'react-intl';

const ItemSchema = {
    title: 'Fax',
    properties: {
        indicazioni: {
            description: "",
            factory: "Text line (String)",
            title: "Etichetta",
            type: "string",
            default: "Ufficio",
        },
        interno: {
            description: "Solo 4 cifre",
            factory: "Text line (String)",
            title: "Interno",
            type: "string",
            validators: [validaInterno],
        },
        principale: {
            description: "Apparirà nella ricerca (selezionare obbligatoriamente almeno un fax come 'Principale')",
            factory: "Yes/No",
            title: "Principale",
            type: "boolean"
        },
        fax: {
            description: "Es: 0805711234",
            factory: "Text line (String)",
            title: "Fax",
            type: "string",
            validators: [validaEsterno],
        }
    },
    fieldsets: [
        {
            id: 'default',
            title: 'Fax',
            fields: [
                'fax',
                'interno',
                'indicazioni',
                'principale',
            ],
        },
    ],
    required: ['indicazioni'],
};

const messages = defineMessages({
    invalidField: {
        id: 'invalidField',
        defaultMessage: 'Valore non valido!',
    }
});

const validFields = {};

const checkValidations = () => {
    const saveButton = document.getElementById('toolbar-save');
    if (!saveButton) return;

    const isValid = Object.values(validFields).every(v => v === true);
    saveButton.disabled = !isValid;
};

const handleBlur = (e, intl) => {
    const field = e.target;
    var res;
    if (field.id.startsWith('field-interno')) {
        res = validaInterno(field.value);
    }

    if (field.id.startsWith('field-fax')) {
        res = validaEsterno(field.value);
    }

    validFields[field.id] = res;

    const errorSpan = field.parentElement.querySelector('.badge.badge-danger');
    if (!res) {
        if (!errorSpan) {
            const error = document.createElement('span');
            error.className = 'badge badge-danger h-25 ms-3 align-self-center';
            error.textContent = intl.formatMessage(messages.invalidField);
            field.parentElement.appendChild(error);
        }
    } else {
        if (errorSpan) {
            errorSpan.remove();
        }
    }

    checkValidations();
};


function addValidationListeners(count, intl) {
    setTimeout(() => {
        const interno_field = document.querySelector('[id^="field-interno-1-fax-' + count + '"]');
        const esterno_field = document.querySelector('[id^="field-fax-0-fax-' + count + '"]');
        if (interno_field) {
            interno_field.addEventListener('blur', (e) => handleBlur(e, intl));
        }
        if (esterno_field) {
            esterno_field.addEventListener('blur', (e) => handleBlur(e, intl));
        }
    }, 500);
}


const FaxWidget = (props) => {
    const intl = useIntl();
    return (
        <ObjectListWidget
            schema={ItemSchema}
            {...props}
            value={props.value?.items || props.default?.items || []}
            onChange={(id, value) => {
                addValidationListeners(value.length - 1, intl);
                props.onChange(id, { items: value })
            }}
        />
    );
};

export default FaxWidget;